import api from './api';

const SKILL_BASE = '/api/skills';

/**
 * List all skills for a database.
 * @param {number} databaseId - ID of the database
 */
export const getSkills = (databaseId) =>
    api.get(`${SKILL_BASE}?database_id=${databaseId}`);

/**
 * List area subfolders under skills/ for a database.
 * @param {number} databaseId
 */
export const getSkillFolders = (databaseId) =>
    api.get(`${SKILL_BASE}/folders?database_id=${databaseId}`);

/**
 * Create an empty skills/<folder>/ directory.
 * @param {{ database_id: number, folder: string }} data
 */
export const createSkillFolder = (data) => api.post(`${SKILL_BASE}/folders`, data);

/**
 * Delete a skills subfolder (removes directory on disk and all related DB rows).
 * @param {number} databaseId
 * @param {string} folder - folder slug / name
 */
export const deleteSkillFolder = (databaseId, folder) =>
    api.delete(
        `${SKILL_BASE}/folders?database_id=${databaseId}&folder=${encodeURIComponent(folder)}`
    );

/**
 * Get a single skill by ID with file content.
 * @param {number} skillId - ID of the skill
 */
export const getSkill = (skillId) =>
    api.get(`${SKILL_BASE}/${skillId}`);

/**
 * Create a new skill (creates file + DB row).
 * @param {Object} skillData - { database_id, name, description, model, body }
 */
export const createSkill = (skillData) =>
    api.post(`${SKILL_BASE}`, skillData);

/**
 * Update an existing skill.
 * @param {number} skillId - ID of the skill
 * @param {Object} skillData - { name, description, model, body }
 */
export const updateSkill = (skillId, skillData) =>
    api.put(`${SKILL_BASE}/${skillId}`, skillData);

/**
 * Delete a skill (removes file + DB row).
 * @param {number} skillId - ID of the skill
 */
export const deleteSkill = (skillId) =>
    api.delete(`${SKILL_BASE}/${skillId}`);

/**
 * Discover skills from .claude/skills/ directory and upsert DB rows.
 * @param {number} databaseId - ID of the database
 */
export const discoverSkills = (databaseId) =>
    api.post(`${SKILL_BASE}/discover?database_id=${databaseId}`);
